import styled from 'styled-components/macro';
import * as Accordion from '@radix-ui/react-accordion';

export const Wrapper = styled(Accordion.Root)`
  border-radius: 6px;
  width: 300px;
`;
